import styled from "styled-components";
import { Row } from 'antd';

export const Content = styled.div`
    display: flex;
    flex: 1;
    flex-direction: ${props=>props.vertical ? 'row' : 'column'};
    flex-basis: auto;

    & input.ant-input{
      // padding-right: 0px;
      // padding-left: 0px;
    }

    & .ant-form-item-label{
      text-align: left;
    }
    & .ant-form-item-label > label::after{
      content: ''
    }
    & .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
        display: inline-block;
        margin-right: 4px;
        color: ${props=>props.theme.palette.primary.focus} !important;
        font-size: 1.3rem;
        font-weight: 400;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: '*';
    }
    & .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
        content: none;
    }

    & .ant-form-item-label{
      font-weight: bold;
    }

    & input:disabled {
      border: none !important;
      background: transparent !important;
      color: #495057;
    }

    &.line {
      border: 1px solid rgba(72, 94, 144, 0.16);
      border-radius: 4px;
    }

    &.line .ant-form-item{

    }

`

export const MainContent = styled.div`
   flex: 1;
   flex-basis: auto;


`

export const ActionContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`
export const RowWrapper = styled(Row)`
  &.line > .ant-col{
    border-bottom: 1px solid rgba(72, 94, 144, 0.16);
  }

  &.line > .ant-col:last-child{
    border-bottom: none;
  }

  &.line .ant-form-item{
    margin-bottom: 0.2rem;
    margin-top: 0.2rem;
  }

  &.line .ant-form-item-label{
    // border-right: 1px solid rgba(72, 94, 144, 0.16);
  }

`
